import { Box, BoxProps, Button, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import "../../party/partyShell.css";

interface AuthFormContainerProps extends BoxProps {
  children: React.ReactNode;
}

const AuthFormContainer: React.FC<AuthFormContainerProps> = ({
  children,
  sx,
  ...props
}) => {
  const navigate = useNavigate();
  const { i18n, t } = useTranslation();
  const rtl = i18n.language === "ar";

  return (
    <Box
      className="party-shell-root"
      dir={rtl ? "rtl" : "ltr"}
      lang={i18n.language || "ar"}
      data-party-theme="midnight"
      data-party-type="rubik"
      sx={{
        minHeight: "100vh",
        width: "100%",
        ...sx,
      }}
      {...props}
    >
      <Box className="party-app-frame" sx={{ mx: "auto", px: 2, py: 2 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            mb: 2,
            gap: 1,
          }}
        >
          <Button
            type="button"
            variant="text"
            onClick={() => navigate("/")}
            className="party-mono"
            sx={{
              border: "1px solid var(--ink-faint)",
              bgcolor: "rgba(255,255,255,0.06)",
              color: "var(--ink-dim)",
              borderRadius: 999,
              px: 1.75,
              py: 1,
              fontSize: 12,
              textTransform: "none",
            }}
          >
            {t("common.back")}
          </Button>
          <Typography className="party-mono" sx={{ fontSize: 11, color: "var(--ink-faint)", letterSpacing: "0.12em" }}>
            {t("party.auth.brandStrip")}
          </Typography>
        </Box>

        <Box
          className="party-kan-card"
          sx={{
            ["--card-bg" as string]: "var(--bg-2)",
            p: { xs: 2.5, sm: 3, md: 4 },
            color: "var(--ink)",
            "& .MuiTypography-root": {
              color: "var(--ink)",
            },
            "& .MuiTypography-colorTextSecondary": {
              color: "var(--ink-dim) !important",
            },
            "& .MuiAlert-root": {
              backgroundColor: "rgba(255,255,255,0.08)",
              color: "var(--ink)",
              border: "1px solid var(--ink-faint)",
            },
            "& .MuiAlert-icon": {
              color: "var(--hot)",
            },
            "& .MuiAlert-standardError": {
              borderColor: "color-mix(in oklab, var(--danger) 45%, transparent)",
            },
            "& .MuiAlert-standardSuccess": {
              borderColor: "color-mix(in oklab, var(--mint) 45%, transparent)",
            },
          }}
        >
          <Box
            component="img"
            src="/assets/kan.png"
            alt="Kan"
            onClick={() => navigate("/")}
            sx={{
              height: { xs: 56, sm: 64 },
              width: "auto",
              objectFit: "contain",
              display: "block",
              mx: "auto",
              mb: 2,
              cursor: "pointer",
              opacity: 0.95,
              filter: "drop-shadow(0 6px 16px rgba(0,0,0,0.35))",
            }}
          />
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default AuthFormContainer;
